import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style
import 'swiper/swiper.scss'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
